import { POSITIONS } from '../../../types/positions/positions';
export const getTextOrIcon = (position, inputValues, offText, onText) => position === POSITIONS.CENTER
    ? inputValues?.centerInputValue
    : position === POSITIONS.RIGHT
        ? onText?.content
        : offText?.content;
//# sourceMappingURL=getTextOrIcon.js.map